import { Bird, Camera, Leaf } from "@phosphor-icons/react";
import { Card, CardContent } from "@/components/ui/card";

const Stats = ({ stats }) => {
  const statItems = [
    { label: "Entries", value: stats.total_entries, icon: Leaf },
    { label: "Species", value: stats.total_species_identified, icon: Bird },
    { label: "Photos", value: stats.total_photos, icon: Camera },
  ];

  return (
    <div className="grid grid-cols-3 gap-1.5 sm:gap-4 mb-8">
      {statItems.map(({ label, value, icon: Icon }) => (
        <Card key={label} className="bg-white border-[#D2C2B3]">
          <CardContent className="p-1.5 sm:p-4 flex flex-col sm:flex-row items-center sm:gap-3 text-center sm:text-left">
            <div className="p-1 sm:p-2 bg-[#EAE7DE] rounded-lg shrink-0 mb-0.5 sm:mb-0">
              <Icon size={14} weight="duotone" className="text-[#55624F] sm:hidden" />
              <Icon size={20} weight="duotone" className="text-[#55624F] hidden sm:block" />
            </div>
            <div className="min-w-0">
              <p className="text-sm sm:text-2xl font-heading font-semibold text-[#2E332B]">{value}</p>
              <p className="text-[10px] sm:text-sm text-[#7C8068]">{label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default Stats;
